import { render } from "./AppUpdateStaff.vue?vue&type=template&id=5bfc7815&scoped=true"
import script from "./AppUpdateStaff.vue?vue&type=script&lang=js"
export * from "./AppUpdateStaff.vue?vue&type=script&lang=js"

import "./AppUpdateStaff.vue?vue&type=style&index=0&id=5bfc7815&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfc7815"]])

export default __exports__